import type { SVGProps } from 'react';
const SvgEditRoad = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#edit_road_svg__a)">
      <path d="M18 4h-2v7.9l2-2V4ZM6 4H4v16h2V4ZM12 4h-2v4h2V4ZM12 10h-2v4h2v-4ZM12 16h-2v4h2v-4ZM22.56 12.59l-1.15-1.15a1.49 1.49 0 0 0-2.12 0L14 16.73V20h3.27l5.29-5.29c.59-.59.59-1.54 0-2.12Zm-5.98 5.86h-1.03v-1.03L19 13.97 20.03 15l-3.45 3.45Z" />
    </g>
    <defs>
      <clipPath id="edit_road_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgEditRoad;
